import LineText from "../LineText";
import React from "react";
import styles from "./styles.module.css";
import { removeLeadingZeros } from "../../utils";
import ParagraphText from "../ParagraphText";
const UBInput = ({
  error = { text: "Error!", show: false },
  iconComponent = null,
  inputClassname = "",
  baseClassname = "",
  required = false,
  inputId = "",
  prefix = "",
  suffix = "",
  baseId = "",
  inputRef,
  onChange,
  onlyNumbers,
  acceptDec,
  name,
  label = "",
  id = "",
  isLeadingZero = true,
  infoLabel = "",
  onInputContainerClick = () => {},
  multiline = false, //NEW PROP
  rows = 3, //OPTIONAL for textarea
  resize = "none", //OPTIONAL for textarea
  handleSuffix,
  onKeyDown,
  ...props
}) => {
  const { className, disabled, ...rest } = props;
  const shouldShowErrorRow = error !== false;
  const errorObj = typeof error === "object" && error !== null ? error : { show: false, text: "" };
  const labelColorClass = disabled ? "newLightColor" : "newFontColor";

  const handleOnChange = (text) => {
    if (onlyNumbers) {
      if (/^\d+$/.test(text) || !text) {
        onChange(name, isLeadingZero ? removeLeadingZeros(text) : text);
      }
    } else if (acceptDec) {
      if (/^\d*\.?\d*$/.test(text) || !text) {
        onChange(name, isLeadingZero ? removeLeadingZeros(text) : text);
      }
    } else {
      onChange(name, text);
    }
  };
  return (
    <div className={`${baseClassname} ${styles.inputParentBaseStyle} inputParentBaseStyle`} id={baseId}>
      {label && (
        <ParagraphText
          className={`fontSize14 ${labelColorClass} InputLabelStyle mb-2`}
        >
          <span>
            {label} {required && <span className="foundationErrorRed">*</span>}
          </span>
          {infoLabel && (
            <ParagraphText className={"fontSize10 newLightColor"}>
              {infoLabel}
            </ParagraphText>
          )}
        </ParagraphText>
      )}
      <div
        id={id}
        className={`input_parent_base_style ${className}`}
        onClick={onInputContainerClick}
      >
        {prefix && <span className="ubInputPrefix">{prefix}</span>}
        {multiline ? (
          <textarea
            id={inputId}
            name={name}
            rows={rows}
            className={`input_base_style ${inputClassname} ${errorObj.show ? styles.errorBorder : ""}`}
            ref={inputRef}
            resize={resize}
            disabled={disabled}
            onChange={(e) => handleOnChange(e.target.value)}
            {...rest}
            placeholder=""
          />
        ) : (
          <input
            autoComplete="off"
            id={inputId}
            name={name}
            className={`input_base_style ${inputClassname} ${errorObj.show ? styles.errorBorder : ""}`}
            ref={inputRef}
            onKeyDown={onKeyDown}
            disabled={disabled}
            onChange={(e) => handleOnChange(e.target.value)}
            {...rest}
          />
        )}
        {suffix && (
          <span className="ubInputSuffix" onClick={handleSuffix ? handleSuffix : ""}>
            {suffix}
          </span>
        )}
      </div>
      {shouldShowErrorRow ? (
        errorObj.show ? (
          <ParagraphText className={`inputError ${styles.inputError}`}>
            {errorObj.text}
          </ParagraphText>
        ) : label ? (
          <ParagraphText className={`inputError ${styles.inputError}`}>
            &nbsp;
          </ParagraphText>
        ) : (
          <></>
        )
      ) : null}
    </div>
  );
};

export default UBInput;
